import React, { useState } from 'react';
import { View, Text, StyleSheet } from 'react-native';

import {
  DownloadButton,
  downloadReport
} from 'app/src/elements/ReportDownload'

import { cardStyles as styles } from './index';

const FeesNotApprovedReport = ({ data }) => {
  const handleDownload = downloadProps => {
    downloadReport({
      ...downloadProps,
      path: 'fees-not-approved-report',
    })
  }

  return (
    <View style={styles.container}>
      <Text style={styles.title}>Fees Not Approved Report</Text>
      <DownloadButton handleDownload={handleDownload} />
    </View>
  )
};

export default FeesNotApprovedReport;
